module.exports = __webpack_public_path__ + "static/Remigijus_Lapinskas-5c848c4379478dba3aeb70de85b1b401.jpg";